import {create} from 'zustand';
import {LoadingKeys} from '@/constants';

export interface ILoadingStoreType {
  loadingObj: Record<LoadingKeys, boolean>;
  setLoading: (key: LoadingKeys, isLoading: boolean) => void;
  getLoading: (key: LoadingKeys) => boolean;
  emptyLoadingObject: () => void;
}

export const loadingStore = create<ILoadingStoreType>((set, get) => ({
  loadingObj: {} as Record<LoadingKeys, boolean>,
  emptyLoadingObject: () => {
    set(() => ({
      loadingObj: {} as Record<LoadingKeys, boolean>,
    }));
  },
  setLoading: async (key: LoadingKeys, isLoading: boolean) => {
    set(({loadingObj}) => ({
      loadingObj: {...loadingObj, [key]: isLoading},
    }));
  },
  getLoading: (key: LoadingKeys) => get().loadingObj[key] ?? false,
}));
